import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  useTheme
} from '@mui/material';
import { optionProfile } from '../../constant/Constants';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';

const buttonStyle = {
  cursor: 'default', 
  fontSize: FontSize.Big, 
  color: Color.Main, 
  '&:hover':  {
   background: Color.Button, color: Color.Dangerous 
 }
};
const boxStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column'
};
const marginTopStyle = {mb: 2};
const buttonSave = {
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Main }
};
const boxBtnStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  p: 2
};

export const UpdateInfo = (props) => {
  const theme = useTheme()

  const [values, setValues] = useState({
    email: 'huytv@openwaygroup.com',
    phone: '0376624470',
    details: 'Tổ dân phố Nghĩa Lộ, phường Phùng Chí Kiên',
    district: ' thị xã Mỹ Hào',
    province: 'tỉnh Hưng Yên',
    country: 'VIET NAM',
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  return (
    <form>
      <Card>
        <CardHeader
          title={<Box sx={boxStyle}>
            <Button
              id="update-info"
              sx={buttonStyle}
              endIcon={<EditIcon />}>
              Update  Profile
            </Button>
          </Box>
          } />
        <Divider sx={marginTopStyle} />
        <CardContent>
          <Grid container spacing={3} >
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                onChange={handleChange}
                required
                value={values.email}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                },
                '& .MuiOutlinedInput-root': {
                    bgcolor: theme.palette.background.default
                },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Box sx={boxBtnStyle}>
          <Button
            sx={buttonSave}
            variant="contained"
            endIcon={<SaveIcon fontSize="small"></SaveIcon>}
            onClick={() => {
              props.update(optionProfile.DEFAULT)
            }}
          >
            Save
          </Button>
        </Box>
      </Card>
    </form>
  );
};
